// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new_btn:hover {
  background-color: rgb(69, 133, 46) !important;
  color: rgb(245, 245, 246) !important;
}

.formTitle {
  color: #3a7425;
  font-size: 1.25rem;
  font-family: Inter;
}

.formHeading {
  font-family: Inter;
  font-size: 24px;
  font-weight: 600;
  padding-left: 13px;
  line-height: 36px;
  letter-spacing: -0.02em;
  text-align: left;
  color: rgba(0, 0, 0, 0.8980392157);
}

.uploadBox {
  position: absolute;
  height: -webkit-fill-available;
  opacity: 0;
  right: 0;
  left: 0;
  cursor: pointer;
}

.bbtn_color {
  background-color: #80b036;
}

.btn.fileUploadBox {
  font-family: Inter;
  border-radius: 8px;
  border: 1px dashed rgba(69, 133, 46, 0.4);
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  position: relative;
  font-size: 16px;
  max-height: 86px;
}

.fileUploadBox.reupload {
  width: auto;
  border: none;
}

.fileUploadBox.download_button {
  border: 0.74px dashed rgba(7, 99, 184, 0.5019607843);
  background: linear-gradient(0deg, rgba(7, 99, 184, 0.1), rgba(7, 99, 184, 0.1));
}

.footerBtnPatch {
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.uploadbtnNew {
  width: 100%;
  height: 100%;
  right: 0;
  top: 0;
  cursor: pointer;
}

.multi-select-form [class*=-control],
.multi-select-form [class*=-control]:focus {
  background: #fff;
  border-color: transparent;
  border: none;
  border-radius: 10px;
  width: 100%;
  font-size: 16px;
  transition: all 0.3s ease-in-out;
  box-shadow: none;
}
.multi-select-form [class*=-control] [class*=-ValueContainer],
.multi-select-form [class*=-control]:focus [class*=-ValueContainer] {
  padding: 0;
}
.multi-select-form [class*=-control] [class*=-placeholder],
.multi-select-form [class*=-control]:focus [class*=-placeholder] {
  color: #000;
}

.file-name {
  max-width: 300px;
  overflow: hidden;
  font-size: 14px;
}

.uploaded-file-name {
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  color: #ffffff;
}

.uploaded-file-timing {
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  line-height: 19.2px;
  letter-spacing: 0.3199999928px;
}

.multi-select-form.form-control,
.disable-multi-select {
  display: flex;
  color: #000;
  width: 100%;
  min-height: 50px;
  height: auto;
  padding-left: 0;
  padding-right: 0;
}

.mandatory-indicator {
  color: red;
  vertical-align: top;
}

.multisection {
  border-bottom: 1px solid rgba(51, 51, 51, 0.24);
  margin-bottom: 10px;
}

.multisection:last-child {
  border: none;
  margin-bottom: 10px;
}

input::-webkit-calendar-picker-indicator,
.date-picker {
  cursor: pointer;
}

.react-datepicker-wrapper {
  display: block !important;
}

.date-input-container {
  position: relative;
}

.date-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 99;
}

.modal-footer {
  /* Adjust space between button and model border */
  border-top: none;
  padding: 0;
  /* border-radius: 20px; */
}

.modal-content {
  /* Adjust space width and radius model border */
  width: 100%;
  border-radius: 25px;
}

.modal-body {
  /* Adjust space padding and margin */
  padding: 0;
  margin-bottom: 3rem;
}

.btn-reupload {
  /* Adjust border radius of re-upload button */
  border-radius: 20px;
}

.modelBox {
  position: relative;
}

.modal {
  --bs-modal-margin: 9.75rem;
}

.fontsize {
  font-size: 12px;
}

.scrutinyPara {
  height: 150px;
}

.btn.success-modal {
  background-color: #45852e;
  color: #fff;
  border-radius: 10px;
}

.btn.error-modal {
  background-color: rgb(255, 0, 0);
  color: #fff;
  border-radius: 10px;
}

.btn.warning-modal {
  background-color: #d7be3a;
  color: #fff;
  border-radius: 10px;
}

.file-form-label {
  font-weight: unset;
  margin-top: 0;
  text-wrap: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: Inter;
}

.progressbar_parents {
  position: relative;
}
.progressbar_parents .progressbar {
  position: relative;
  height: 20px;
  border-radius: 40px;
  background: #ebebeb;
}
.progressbar_parents .progressbar .inner_bar {
  position: absolute;
  inset: 0px;
  height: 20px;
  border-radius: 40px;
  background: linear-gradient(270deg, #45852e 40.36%, #80b036 100%);
}
.progressbar_parents .progress_checkout_person {
  width: 500%;
  text-align: center;
  left: -180%;
}
.progressbar_parents .progress_checkout_person .arrow {
  position: absolute;
  inset: 20px auto 0px auto;
  height: 10px;
  width: 30px;
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
  transform: rotate(180deg);
  display: flex;
  justify-content: center;
}
.progressbar_parents .progress_checkout_person .name_of_person {
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: -0.02em;
  text-align: center;
}
.progressbar_parents .progress_checkout_person .designation_of_person {
  font-family: Inter;
  font-size: 10px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.02em;
}
.progressbar_parents .progress_checkout_person .date_of_checkout {
  font-family: Inter;
  font-size: 10px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.02em;
}
.progressbar_parents .active {
  color: #45852e;
}

.progress-check {
  position: absolute;
  right: 0px;
  top: 50%;
  transform: translate(-50%, -50%);
}

.progress-uncheck {
  position: absolute;
  right: 0;
  height: 100%;
}

.verify-btn-otp {
  position: relative;
  inset: 32px 0px 0px auto;
  max-height: 47px;
}

.download_template_parents {
  background-color: #f5f5f6;
}
.download_template_parents .download_template_heading {
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 17px;
  text-align: left;
}
.download_template_parents #selectAll::before {
  border-width: 0 2px 0px 0;
  transform: rotate(90deg) translate(-105%, -24%);
}
.download_template_parents .select_all {
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 17px;
  letter-spacing: 0em;
}
.download_template_parents .common_label {
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.03em;
  text-align: left;
}

.edit {
  color: #3a7425;
  cursor: pointer;
}

.close {
  color: #c44744;
  cursor: pointer;
}

.radio-disabled {
  color: #858585;
  cursor: auto !important;
}
.radio-disabled input[type=radio] {
  cursor: auto !important;
}

.radio-disabled input[type=radio]:checked {
  border-color: #333;
  background-color: #888888;
  cursor: auto !important;
}

.generic-action-table,
.ownership-table {
  font-family: Karla;
  display: inline;
}
.generic-action-table .bg,
.ownership-table .bg {
  border-radius: 16px;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  letter-spacing: -0.28px;
}
.generic-action-table .Active-status,
.ownership-table .Active-status {
  line-height: 100%;
  background: #f3f9f0;
  color: #238e1a;
  padding: 10px 0;
}
.generic-action-table .Inactive,
.ownership-table .Inactive {
  line-height: 100%;
  background: #ffeaea;
  color: #c51a1a;
  padding: 10px 0;
}
.generic-action-table .pagination-count-button,
.ownership-table .pagination-count-button {
  background-color: white;
  color: black;
  border-color: white;
}

.Inactive-status {
  line-height: 100%;
  background: #ffeaea;
  color: #c51a1a;
  padding: 10px 0;
}

.ACTIVE-status {
  line-height: 100%;
  background: #f3f9f0;
  color: #238e1a;
  padding: 10px 0;
}

.INACTIVE-status {
  line-height: 100%;
  background: #ffeaea;
  color: #c51a1a;
  padding: 10px 0;
}

.Pending.for.Modification-status {
  height: fit-content;
  border-radius: 16px;
  background: #f9f7d7;
  color: #9a7500;
  font-family: Karla;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 250%;
  letter-spacing: -0.28px;
}

.Desk-Pendency-Valid {
  background: #f9f7d7;
  border-radius: 16px;
  color: #9a7500;
}

.Desk-Pendency-notValid {
  border-radius: 16px;
  background: #f3f9f0;
  color: #238e1a;
}

.Desk-Pendency-Dash {
  border-radius: 16px;
}

.button-basic, .Rejected-status,
.Failed-status, .Approved-status,
.Open-status,
.Passed-status,
.DONE-status,
.APPROVED-status, .Draft-status,
.Pending-status,
.Not.Verified-status,
.PENDING-status {
  height: fit-content;
  border-radius: 11.85px;
  font-family: Karla;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 250%;
  letter-spacing: -0.28px;
}

.Draft-status,
.Pending-status,
.Not.Verified-status,
.PENDING-status {
  background: #f9f7d7;
  color: #9a7500;
}

.Approved-status,
.Open-status,
.Passed-status,
.DONE-status,
.APPROVED-status {
  background: #dfefdc;
  color: #238e1a;
}

.Rejected-status,
.Failed-status {
  background: #ffeaea;
  color: #c51a1a;
}

.noc_heading {
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0px;
  text-align: left;
  color: rgba(0, 0, 0, 0.8);
}

.noc_title {
  font-family: Inter;
  font-size: 12px;
  font-weight: 600;
  line-height: 19px;
  letter-spacing: 0px;
  text-align: left;
  color: rgba(0, 0, 0, 0.8980392157);
}

.noc_add_fields {
  height: 44px;
  border-radius: 6px;
  border: 0.74px dashed #45852e;
  background: rgba(69, 133, 46, 0.1019607843);
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  color: #212529;
}

.add_fields {
  height: 44px;
  border-radius: 6px;
  border: 0.74px #45852e;
  background: #45852e;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}

.select-disabled {
  background-color: #e9ecef !important;
  opacity: 1 !important;
  border: 0 !important;
}

.tooltip-style {
  font-family: Inter !important;
  min-width: 202px !important;
  max-width: 456px !important;
  box-sizing: border-box !important;
  height: fit-content;
  padding: 6px 8px 6px 8px !important;
  border-radius: 8px !important;
  border: 1px solid #45852e !important;
  font-size: 12px !important;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.01em;
  pointer-events: all !important;
}
.tooltip-style .tooltip-content {
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.01em;
}
.tooltip-style a {
  color: #45852e;
}

.tooltip-container[data-popper-placement*=bottom] .tooltip-arrow::before {
  border-color: transparent transparent #45852e transparent !important;
}

.tooltip-container[data-popper-placement*=right] .tooltip-arrow::before {
  border-color: transparent #45852e transparent transparent !important;
}

.generic-table-radio-field {
  appearance: none !important;
  border: 0.74px solid #b9b9b9 !important;
  background-color: transparent !important;
  cursor: pointer !important;
}

.generic-table-radio-field:checked {
  border: 3px solid #45852e !important;
}

.modal-img {
  position: absolute;
  width: 80px;
  height: 80px;
  /* border-radius: 80px; */
  cursor: pointer;
  transform: translate(-50%, -50%);
  left: 50%;
  margin-top: 60px;
}

.showBackBtns {
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.showBackBtns.visible {
  opacity: 1;
  transform: translateY(0);
}

.sc-bbSZdi {
  overflow: unset !important;
}

.custom-switch {
  display: flex;
  align-items: center;
}

.custom-switch input {
  display: none;
}

.custom-switch label {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.custom-switch .slider {
  position: relative;
  width: 34px;
  height: 20px;
  background-color: #ccc;
  border-radius: 34px;
  transition: background-color 0.2s;
}

.custom-switch .slider:before {
  position: absolute;
  content: "";
  height: 12px;
  width: 12px;
  border-radius: 50%;
  background-color: white;
  top: 4px;
  left: 4px;
  transition: transform 0.2s;
}

.custom-switch input:checked + .slider {
  background-color: #66bb6a;
}

.custom-switch input:checked + .slider:before {
  transform: translateX(14px);
}

.checkmark-position {
  padding-right: 28px !important;
}

.pagination-ownership-count-button {
  background-color: white;
  color: black;
  border-color: rgb(120, 122, 123);
}

.jodit-workplace .jodit-wysiwyg {
  overflow-y: hidden;
}`, "",{"version":3,"sources":["webpack://./src/components/moduleCommonFormik/GenericStyles.scss"],"names":[],"mappings":"AAOA;EACI,6CAAA;EACA,oCAAA;AANJ;;AASA;EACI,cAAA;EACA,kBAAA;EACA,kBAAA;AANJ;;AASA;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kCAAA;AANJ;;AASA;EACI,kBAAA;EACA,8BAAA;EACA,UAAA;EACA,QAAA;EACA,OAAA;EACA,eAAA;AANJ;;AASA;EACI,yBAAA;AANJ;;AASA;EACI,kBAAA;EACA,kBAAA;EACA,yCAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AANJ;;AASA;EACI,WAAA;EACA,YAAA;AANJ;;AASA;EACI,oDAAA;EACA,+EAAA;AANJ;;AASA;EACI,sBAAA;EACA,qCAAA;AANJ;;AASA;EACI,WAAA;EACA,YAAA;EACA,QAAA;EACA,MAAA;EACA,eAAA;AANJ;;AASA;;EAEI,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gCAAA;EACA,gBAAA;AANJ;AAQI;;EACI,UAAA;AALR;AAQI;;EACI,WAAA;AALR;;AASA;EAEI,gBAAA;EACA,gBAAA;EACA,eAAA;AAPJ;;AASA;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AANJ;;AAQA;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,8BAAA;AALJ;;AAQA;;EAEI,aAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AALJ;;AAQA;EACI,UAAA;EACA,mBAAA;AALJ;;AAQA;EACI,+CAAA;EACA,mBAAA;AALJ;;AAQA;EACI,YAAA;EACA,mBAAA;AALJ;;AAQA;;EAEI,eAAA;AALJ;;AAQA;EACI,yBAAA;AALJ;;AAQA;EACI,kBAAA;AALJ;;AAOA;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;AAJJ;;AASA;EACI,iDAAA;EACA,gBAAA;EACA,UAAA;EACA,yBAAA;AANJ;;AASA;EACI,+CAAA;EACA,WAAA;EACA,mBAAA;AANJ;;AASA;EACI,oCAAA;EACA,UAAA;EACA,mBAAA;AANJ;;AASA;EACI,6CAAA;EACA,mBAAA;AANJ;;AASA;EACI,kBAAA;AANJ;;AASA;EACI,0BAAA;AANJ;;AASA;EACI,eAAA;AANJ;;AASA;EACI,aAAA;AANJ;;AASA;EACI,yBAAA;EACA,WAAA;EACA,mBAAA;AANJ;;AASA;EACI,gCAAA;EACA,WAAA;EACA,mBAAA;AANJ;;AASA;EACI,yBAAA;EACA,WAAA;EACA,mBAAA;AANJ;;AASA;EACI,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EAEA,kBAAA;AAPJ;;AAUA;EACI,kBAAA;AAPJ;AASI;EACI,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AAPR;AASQ;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,iEAAA;AAPZ;AAWI;EACI,WAAA;EACA,kBAAA;EACA,WAAA;AATR;AAUQ;EACI,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,8CAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;AARZ;AAWQ;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;AATZ;AAYQ;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AAVZ;AAaQ;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AAXZ;AAeI;EACI,cAxSK;AA2Rb;;AAiBA;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,gCAAA;AAdJ;;AAiBA;EACI,kBAAA;EACA,QAAA;EACA,YAAA;AAdJ;;AAiBA;EACI,kBAAA;EACA,wBAAA;EACA,gBAAA;AAdJ;;AAmBA;EACI,yBAAA;AAhBJ;AAkBI;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAhBR;AAmBI;EACI,yBAAA;EACA,+CAAA;AAjBR;AAoBI;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAlBR;AAqBI;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;AAnBR;;AAuBA;EACI,cAAA;EACA,eAAA;AApBJ;;AAuBA;EACI,cAAA;EACA,eAAA;AApBJ;;AAyBA;EACI,cAAA;EACA,uBAAA;AAtBJ;AAuBI;EACI,uBAAA;AArBR;;AAyBA;EACI,kBAAA;EACA,yBAAA;EACA,uBAAA;AAtBJ;;AA2CA;;EAEI,kBAAA;EACA,eAAA;AAxCJ;AAyCI;;EACI,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;AAtCR;AAyCI;;EACI,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAtCR;AAyCI;;EACI,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAtCR;AAwCI;;EACI,uBAAA;EACA,YAAA;EACA,mBAAA;AArCR;;AAwCA;EACI,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AArCJ;;AAwCA;EACI,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AArCJ;;AAwCA;EACI,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AArCJ;;AA8DA;EACI,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AA3DJ;;AAyEA;EACI,mBAAA;EACA,mBAAA;EACA,cAAA;AAtEJ;;AAwEA;EACI,mBAAA;EACA,mBAAA;EACA,cAAA;AArEJ;;AAwEA;EAEI,mBAAA;AAtEJ;;AAyEA;;;;;;;;;EACI,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EAIA,gBAAA;EACA,iBAAA;EACA,uBAAA;AAjEJ;;AAmEA;;;;EAKI,mBAAA;EACA,cAAA;AAjEJ;;AAwEA;;;;;EAMI,mBAAA;EACA,cAAA;AAtEJ;;AAyEA;;EAGI,mBAAA;EACA,cAAA;AAvEJ;;AA0EA;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;AAvEJ;;AAyEA;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kCAAA;AAtEJ;;AAwEA;EACI,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,2CAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AArEJ;;AAuEA;EACI,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AApEJ;;AAsEA;EACI,oCAAA;EACA,qBAAA;EACA,oBAAA;AAnEJ;;AAqEA;EACI,6BAAA;EACA,2BAAA;EACA,2BAAA;EACA,iCAAA;EACA,mBAAA;EACA,mCAAA;EACA,6BAAA;EACA,oCAAA;EACA,0BAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,8BAAA;AAlEJ;AAmEI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AAjER;AAoEI;EACI,cAAA;AAlER;;AAuEQ;EACI,oEAAA;AApEZ;;AA2EQ;EACI,oEAAA;AAxEZ;;AA6EA;EACI,2BAAA;EACA,uCAAA;EACA,wCAAA;EACA,0BAAA;AA1EJ;;AA6EA;EACI,oCAAA;AA1EJ;;AA6EA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,gCAAA;EACA,SAAA;EACA,gBAAA;AA1EJ;;AA6EA;EACI,UAAA;EACA,2BAAA;EACA,kDACI;AA3ER;;AA+EA;EACI,UAAA;EACA,wBAAA;AA5EJ;;AA+EA;EACI,0BAAA;AA5EJ;;AA+EA;EACI,aAAA;EACA,mBAAA;AA5EJ;;AA+EA;EACI,aAAA;AA5EJ;;AA+EA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;AA5EJ;;AA+EA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,iCAAA;AA5EJ;;AA+EA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;EACA,0BAAA;AA5EJ;;AA+EA;EACI,yBAAA;AA5EJ;;AA+EA;EACI,2BAAA;AA5EJ;;AA8EA;EACI,8BAAA;AA3EJ;;AA8EA;EACI,uBAAA;EACA,YAAA;EACA,gCAAA;AA3EJ;;AA+EA;EACI,kBAAA;AA5EJ","sourcesContent":["$back-color: #45852e;\n\n// .back_sqaure.btn-primary:hover {\n//     background-color: rgb(253, 253, 253) !important;\n//     color: rgb(0, 0, 0) !important;\n// }\n\n.new_btn:hover {\n    background-color: rgb(69, 133, 46) !important;\n    color: rgb(245, 245, 246) !important;\n}\n\n.formTitle {\n    color: #3a7425;\n    font-size: 1.25rem;\n    font-family: Inter;\n}\n\n.formHeading {\n    font-family: Inter;\n    font-size: 24px;\n    font-weight: 600;\n    padding-left: 13px;\n    line-height: 36px;\n    letter-spacing: -0.02em;\n    text-align: left;\n    color: #000000e5;\n}\n\n.uploadBox {\n    position: absolute;\n    height: -webkit-fill-available;\n    opacity: 0;\n    right: 0;\n    left: 0;\n    cursor: pointer;\n}\n\n.bbtn_color {\n    background-color: #80b036;\n}\n\n.btn.fileUploadBox {\n    font-family: Inter;\n    border-radius: 8px;\n    border: 1px dashed rgba(69, 133, 46, 0.4);\n    background: rgba(255, 255, 255, 0.8);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 0;\n    position: relative;\n    font-size: 16px;\n    max-height: 86px;\n}\n\n.fileUploadBox.reupload {\n    width: auto;\n    border: none;\n}\n\n.fileUploadBox.download_button {\n    border: 0.74px dashed #0763b880;\n    background: linear-gradient(0deg, rgba(7, 99, 184, 0.1), rgba(7, 99, 184, 0.1));\n}\n\n.footerBtnPatch {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.12);\n}\n\n.uploadbtnNew {\n    width: 100%;\n    height: 100%;\n    right: 0;\n    top: 0;\n    cursor: pointer;\n}\n\n.multi-select-form [class*='-control'],\n.multi-select-form [class*='-control']:focus {\n    background: #fff;\n    border-color: transparent;\n    border: none;\n    border-radius: 10px;\n    width: 100%;\n    font-size: 16px;\n    transition: all 0.3s ease-in-out;\n    box-shadow: none;\n\n    & [class*='-ValueContainer'] {\n        padding: 0;\n    }\n\n    & [class*='-placeholder'] {\n        color: #000;\n    }\n}\n\n.file-name {\n    // height: 50px;\n    max-width: 300px;\n    overflow: hidden;\n    font-size: 14px;\n}\n.uploaded-file-name {\n    font-family: Inter;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 18px;\n    color: #ffffff;\n}\n.uploaded-file-timing {\n    font-family: Inter;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 19.2px;\n    letter-spacing: 0.3199999928474426px;\n}\n\n.multi-select-form.form-control,\n.disable-multi-select {\n    display: flex;\n    color: #000;\n    width: 100%;\n    min-height: 50px;\n    height: auto;\n    padding-left: 0;\n    padding-right: 0;\n}\n\n.mandatory-indicator {\n    color: red;\n    vertical-align: top;\n}\n\n.multisection {\n    border-bottom: 1px solid rgba(51, 51, 51, 0.24);\n    margin-bottom: 10px;\n}\n\n.multisection:last-child {\n    border: none;\n    margin-bottom: 10px;\n}\n\ninput::-webkit-calendar-picker-indicator,\n.date-picker {\n    cursor: pointer;\n}\n\n.react-datepicker-wrapper {\n    display: block !important;\n}\n\n.date-input-container {\n    position: relative;\n}\n.date-icon {\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    z-index: 99;\n}\n\n// generic popup\n\n.modal-footer {\n    /* Adjust space between button and model border */\n    border-top: none;\n    padding: 0;\n    /* border-radius: 20px; */\n}\n\n.modal-content {\n    /* Adjust space width and radius model border */\n    width: 100%;\n    border-radius: 25px;\n}\n\n.modal-body {\n    /* Adjust space padding and margin */\n    padding: 0;\n    margin-bottom: 3rem;\n}\n\n.btn-reupload {\n    /* Adjust border radius of re-upload button */\n    border-radius: 20px;\n}\n\n.modelBox {\n    position: relative;\n}\n\n.modal {\n    --bs-modal-margin: 9.75rem;\n}\n\n.fontsize {\n    font-size: 12px;\n}\n\n.scrutinyPara {\n    height: 150px;\n}\n\n.btn.success-modal {\n    background-color: #45852e;\n    color: #fff;\n    border-radius: 10px;\n}\n\n.btn.error-modal {\n    background-color: rgb(255, 0, 0);\n    color: #fff;\n    border-radius: 10px;\n}\n\n.btn.warning-modal {\n    background-color: #d7be3a;\n    color: #fff;\n    border-radius: 10px;\n}\n\n.file-form-label {\n    font-weight: unset;\n    margin-top: 0;\n    text-wrap: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    // width: 100%;\n    font-family: Inter;\n}\n\n.progressbar_parents {\n    position: relative;\n\n    .progressbar {\n        position: relative;\n        height: 20px;\n        border-radius: 40px;\n        background: #ebebeb;\n\n        .inner_bar {\n            position: absolute;\n            inset: 0px;\n            height: 20px;\n            border-radius: 40px;\n            background: linear-gradient(270deg, #45852e 40.36%, #80b036 100%);\n        }\n    }\n\n    .progress_checkout_person {\n        width: 500%;\n        text-align: center;\n        left: -180%;\n        .arrow {\n            position: absolute;\n            inset: 20px auto 0px auto;\n            height: 10px;\n            width: 30px;\n            clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\n            transform: rotate(180deg);\n            display: flex;\n            justify-content: center;\n        }\n\n        .name_of_person {\n            font-family: Inter;\n            font-size: 12px;\n            font-weight: 400;\n            line-height: 21px;\n            letter-spacing: -0.02em;\n            text-align: center;\n        }\n\n        .designation_of_person {\n            font-family: Inter;\n            font-size: 10px;\n            font-weight: 400;\n            line-height: 18px;\n            letter-spacing: -0.02em;\n        }\n\n        .date_of_checkout {\n            font-family: Inter;\n            font-size: 10px;\n            font-weight: 400;\n            line-height: 20px;\n            letter-spacing: -0.02em;\n        }\n    }\n\n    .active {\n        color: $back-color;\n    }\n}\n\n.progress-check {\n    position: absolute;\n    right: 0px;\n    top: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.progress-uncheck {\n    position: absolute;\n    right: 0;\n    height: 100%;\n}\n\n.verify-btn-otp {\n    position: relative;\n    inset: 32px 0px 0px auto;\n    max-height: 47px;\n}\n\n// download teamplate css\n\n.download_template_parents {\n    background-color: #f5f5f6;\n\n    .download_template_heading {\n        font-family: Inter;\n        font-size: 16px;\n        font-weight: 600;\n        line-height: 17px;\n        text-align: left;\n    }\n\n    #selectAll::before {\n        border-width: 0 2px 0px 0;\n        transform: rotate(90deg) translate(-105%, -24%);\n    }\n\n    .select_all {\n        font-family: Inter;\n        font-size: 14px;\n        font-weight: 600;\n        line-height: 17px;\n        letter-spacing: 0em;\n    }\n\n    .common_label {\n        font-family: Inter;\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 20px;\n        letter-spacing: -0.03em;\n        text-align: left;\n    }\n}\n\n.edit {\n    color: #3a7425;\n    cursor: pointer;\n}\n\n.close {\n    color: #c44744;\n    cursor: pointer;\n}\n\n// Generic radio buttons\n\n.radio-disabled {\n    color: #858585;\n    cursor: auto !important;\n    input[type='radio'] {\n        cursor: auto !important;\n    }\n}\n\n.radio-disabled input[type='radio']:checked {\n    border-color: #333;\n    background-color: #888888;\n    cursor: auto !important;\n}\n\n//custom loader if needed\n// .spinner {\n//   animation: spin 4s infinite linear;\n//   width: 100px;\n//   height: 100px;\n//   margin: 20px;\n//   position: absolute;\n// }\n\n// @keyframes spin {\n//   from {\n//     transform: rotate(0deg);\n//   }\n//   to {\n//     transform: rotate(360deg);\n//   }\n// }\n\n.generic-action-table,\n.ownership-table {\n    font-family: Karla;\n    display: inline;\n    .bg {\n        border-radius: 16px;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 500;\n        letter-spacing: -0.28px;\n    }\n\n    .Active-status {\n        line-height: 100%;\n        background: #f3f9f0;\n        color: #238e1a;\n        padding: 10px 0;\n    }\n\n    .Inactive {\n        line-height: 100%;\n        background: #ffeaea;\n        color: #c51a1a;\n        padding: 10px 0;\n    }\n    .pagination-count-button {\n        background-color: white;\n        color: black;\n        border-color: white;\n    }\n}\n.Inactive-status {\n    line-height: 100%;\n    background: #ffeaea;\n    color: #c51a1a;\n    padding: 10px 0;\n}\n\n.ACTIVE-status {\n    line-height: 100%;\n    background: #f3f9f0;\n    color: #238e1a;\n    padding: 10px 0;\n}\n\n.INACTIVE-status {\n    line-height: 100%;\n    background: #ffeaea;\n    color: #c51a1a;\n    padding: 10px 0;\n}\n// .Approved-status {\n//     height: fit-content;\n//     font-family: Karla;\n//     font-size: 14px;\n//     font-style: normal;\n//     font-weight: 500;\n//     line-height: 250%;\n//     letter-spacing: -0.28px;\n// }\n\n// .Pending.for.Approval-status {\n//     height: fit-content;\n//     border-radius: 16px;\n//     background: #f9f7d7;\n//     color: #9a7500;\n//     font-family: Karla;\n//     font-size: 14px;\n//     font-style: normal;\n//     font-weight: 500;\n//     line-height: 250%;\n//     letter-spacing: -0.28px;\n// }\n\n.Pending.for.Modification-status {\n    height: fit-content;\n    border-radius: 16px;\n    background: #f9f7d7;\n    color: #9a7500;\n    font-family: Karla;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 250%;\n    letter-spacing: -0.28px;\n}\n\n// .Pending.for.Verification-status {\n//     height: fit-content;\n//     border-radius: 16px;\n//     background: #f9f7d7;\n//     font-family: Karla;\n//     font-size: 14px;\n//     font-style: normal;\n//     font-weight: 500;\n//     line-height: 250%;\n//     letter-spacing: -0.28px;\n// }\n.Desk-Pendency-Valid {\n    background: #f9f7d7;\n    border-radius: 16px;\n    color: #9a7500;\n}\n.Desk-Pendency-notValid {\n    border-radius: 16px;\n    background: #f3f9f0;\n    color: #238e1a;\n}\n\n.Desk-Pendency-Dash {\n    // background: #f9f7d7;\n    border-radius: 16px;\n    // color: #9a7500;\n}\n.button-basic {\n    height: fit-content;\n    border-radius: 11.85px;\n    font-family: Karla;\n    font-size: 14px;\n    font-style: normal;\n    // width: 115.56px;\n    // margin-right: 150px;\n    // margin-left: 150px;\n    font-weight: 500;\n    line-height: 250%;\n    letter-spacing: -0.28px;\n}\n.Draft-status,\n.Pending-status,\n.Not.Verified-status,\n.PENDING-status {\n    @extend .button-basic;\n    background: #f9f7d7;\n    color: #9a7500;\n}\n// .Closed-status {\n//     @extend .button-basic;\n//     background: #e1f2f9;\n//     color: #00639a;\n// }\n.Approved-status,\n.Open-status,\n.Passed-status,\n.DONE-status,\n.APPROVED-status {\n    @extend .button-basic;\n    background: #dfefdc;\n    color: #238e1a;\n}\n\n.Rejected-status,\n.Failed-status {\n    @extend .button-basic;\n    background: #ffeaea;\n    color: #c51a1a;\n}\n\n.noc_heading {\n    font-family: Inter;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 19px;\n    letter-spacing: 0px;\n    text-align: left;\n    color: #000000cc;\n}\n.noc_title {\n    font-family: Inter;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 19px;\n    letter-spacing: 0px;\n    text-align: left;\n    color: #000000e5;\n}\n.noc_add_fields {\n    height: 44px;\n    border-radius: 6px;\n    border: 0.74px dashed #45852e;\n    background: #45852e1a;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 600;\n    color: #212529;\n}\n.add_fields {\n    height: 44px;\n    border-radius: 6px;\n    border: 0.74px #45852e;\n    background: #45852e;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 600;\n    color: #fff;\n}\n.select-disabled {\n    background-color: #e9ecef !important;\n    opacity: 1 !important;\n    border: 0 !important;\n}\n.tooltip-style {\n    font-family: Inter !important;\n    min-width: 202px !important;\n    max-width: 456px !important;\n    box-sizing: border-box !important;\n    height: fit-content;\n    padding: 6px 8px 6px 8px !important;\n    border-radius: 8px !important;\n    border: 1px solid #45852e !important;\n    font-size: 12px !important;\n    font-weight: 400;\n    line-height: 16px;\n    letter-spacing: 0.01em;\n    pointer-events: all !important;\n    .tooltip-content {\n        font-size: 12px;\n        font-weight: 400;\n        line-height: 16px;\n        letter-spacing: 0.01em;\n    }\n\n    a {\n        color: #45852e;\n    }\n}\n.tooltip-container[data-popper-placement*='bottom'] {\n    .tooltip-arrow {\n        &::before {\n            border-color: transparent transparent #45852e transparent !important;\n        }\n    }\n}\n\n.tooltip-container[data-popper-placement*='right'] {\n    .tooltip-arrow {\n        &::before {\n            border-color: transparent #45852e transparent transparent !important;\n        }\n    }\n}\n\n.generic-table-radio-field {\n    appearance: none !important;\n    border: 0.74px solid #b9b9b9 !important;\n    background-color: transparent !important;\n    cursor: pointer !important;\n}\n\n.generic-table-radio-field:checked {\n    border: 3px solid #45852e !important;\n}\n\n.modal-img {\n    position: absolute;\n    width: 80px;\n    height: 80px;\n    /* border-radius: 80px; */\n    cursor: pointer;\n    transform: translate(-50%, -50%);\n    left: 50%;\n    margin-top: 60px;\n}\n\n.showBackBtns {\n    opacity: 0;\n    transform: translateY(20px);\n    transition:\n        opacity 0.5s ease,\n        transform 0.5s ease;\n}\n\n.showBackBtns.visible {\n    opacity: 1;\n    transform: translateY(0);\n}\n\n.sc-bbSZdi {\n    overflow: unset !important;\n}\n\n.custom-switch {\n    display: flex;\n    align-items: center;\n}\n\n.custom-switch input {\n    display: none;\n}\n\n.custom-switch label {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n}\n\n.custom-switch .slider {\n    position: relative;\n    width: 34px;\n    height: 20px;\n    background-color: #ccc;\n    border-radius: 34px;\n    transition: background-color 0.2s;\n}\n\n.custom-switch .slider:before {\n    position: absolute;\n    content: '';\n    height: 12px;\n    width: 12px;\n    border-radius: 50%;\n    background-color: white;\n    top: 4px;\n    left: 4px;\n    transition: transform 0.2s;\n}\n\n.custom-switch input:checked + .slider {\n    background-color: #66bb6a;\n}\n\n.custom-switch input:checked + .slider:before {\n    transform: translateX(14px);\n}\n.checkmark-position {\n    padding-right: 28px !important;\n}\n\n.pagination-ownership-count-button {\n    background-color: white;\n    color: black;\n    border-color: rgb(120, 122, 123);\n    // outline-color: rgb(120, 122, 123);\n}\n\n.jodit-workplace .jodit-wysiwyg {\n    overflow-y: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
